import { render, staticRenderFns } from "./FlightSearch.vue?vue&type=template&id=352c13ae&scoped=true"
import script from "./FlightSearch.vue?vue&type=script&lang=js"
export * from "./FlightSearch.vue?vue&type=script&lang=js"
import style0 from "./FlightSearch.vue?vue&type=style&index=0&id=352c13ae&prod&lang=scss&scoped=true"
import style1 from "./FlightSearch.vue?vue&type=style&index=1&id=352c13ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c13ae",
  null
  
)

export default component.exports